/**
 * components/RecipeDetailModal.js
 * Read-only view of a typed recipe: type label + name + note + full Input/Output lines (codes resolved
 * to item names via byCode, with the "tidak tersedia" red fallback for missing codes). Esc /
 * click-outside / × / Tutup close. Editing is a later session.
 */
import React from "react";
import { fmtQty } from "../utils/idGenerators";
import { LineName } from "./LineName";
import { useModalEsc, backdropClose } from "../utils/modalStack";

const TYPE_LABEL = { ASSEMBLE: "Rakit (Assemble)", TEARDOWN: "Urai (Teardown)" };

export default function RecipeDetailModal({ recipe, items = [], onEdit, onClose }) {
  useModalEsc(onClose);

  if (!recipe) return null;
  const byCode = new Map(items.map((it) => [it.internalCode, it]));

  const renderLines = (lines = []) =>
    lines.length === 0 ? <div className="form-hint">—</div> : (
      <ul className="recipe-lines">
        {lines.map((l, i) => (
          <li key={i}>
            <span className="mono">{l.internalCode}</span> ·{" "}
            <LineName line={l} byCode={byCode} />
            {" "}× <b>{fmtQty(l.qty)}</b>
          </li>
        ))}
      </ul>
    );

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" style={{ position: "relative" }} onMouseDown={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Tutup">×</button>
        <h2 className="modal-title">{recipe.name}</h2>
        <div className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>{TYPE_LABEL[recipe.type] || recipe.type}</div>
        {recipe.note ? <div className="alert alert--info" style={{ marginBottom: "var(--gap-lg)" }}>{recipe.note}</div> : null}

        <div className="card" style={{ marginBottom: "var(--gap-md)" }}>
          <div className="card__title">Input</div>
          {renderLines(recipe.inputs)}
        </div>
        <div className="card" style={{ marginBottom: 0 }}>
          <div className="card__title">Output</div>
          {renderLines(recipe.outputs)}
        </div>

        <div className="modal-actions">
          <button type="button" className="btn btn-primary" onClick={onEdit}>Ubah</button>
          <button type="button" className="btn" onClick={onClose}>Tutup</button>
        </div>
      </div>
    </div>
  );
}
